import request from './.request'
//查询
export function getDataByEnterpriseId(enterpriseId,e) {
  return request({
    url: `/inputs-invoice/${enterpriseId}?about=stock-simple-list&by=enterprise`,
    method:'get',
    params:e
  })
}
// 采购登记
export function postData(data) {
    return request({
      url: '/inputs-invoice',
      method:'post',
      data:data
    })
}
//库存核销
export function updateInputs(e) {
  return request({
    url: '/inputs-invoice?op=declare',
    method: 'put',
    data: e
  })
}
// 流水情况
export function invoiceList(enterpriseId,e) {
  return request({
    url: `/inputs-invoice/${enterpriseId}?about=invoice-list&by=enterprise`,
    method: 'get',
    params: e
  })
}
/**
* 根据id查该投入品流水情况
*/
 export function invoiceListById(enterpriseId,inputId,e) {
  return request({
    url: `/inputs-invoice/${enterpriseId}/${inputId}?about=invoice-list&by=inputId`,
    method: 'get',
    params: e
  })
}




// WEBPACK FOOTER //
// ./src/api/inputs-invoice.js